/** @deprecated Skapa has a boolean called "small". Use this to set "medium" or "small" size for buttons. */
var ButtonSizeEnum;
(function (ButtonSizeEnum) {
    ButtonSizeEnum["small"] = "small";
    ButtonSizeEnum["medium"] = "medium";
})(ButtonSizeEnum || (ButtonSizeEnum = {}));
export default ButtonSizeEnum;
//# sourceMappingURL=ButtonSizeEnum.js.map